var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlockMarketplace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.5C7.39807 0.5 8.93732 1.9925 8.9375 3.83301V5.16699H9.625C10.384 5.16699 11 5.764 11 6.5V13.167C10.9998 13.9028 10.3839 14.5 9.625 14.5H1.375C0.61612 14.5 0.000182728 13.9028 0 13.167V6.5C3.87691e-06 5.764 0.61601 5.16699 1.375 5.16699H2.0625V3.83301C2.06268 1.9925 3.60192 0.500004 5.5 0.5ZM5.5 1.83398C4.36102 1.83398 3.43772 2.7296 3.4375 3.83398V5.16797H7.5625V3.83398C7.56228 2.7296 6.63898 1.83399 5.5 1.83398Z",
    fill: "#71717A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockMarketplace);
export default __webpack_public_path__ + "static/media/padlockMarketplace.f2662f40eee231ab41371798c90e1730.svg";
export { ForwardRef as ReactComponent };